import React from 'react';
import cx from './index.module.scss';

const MemberWrapper = ({ title, children, ...props }) => {
  return (
    <div className={cx('wrapper')}>
      <div className={cx('title')}>{title}：</div>
      <div>{React.cloneElement(children, props)}</div>
    </div>
  );
};

export { MemberWrapper };
